import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"
import {
  pageFooterContainerMotion,
  pageFooterItemMotion,
} from "./framerAnimations"

const duration = 0.05

const container = pageFooterContainerMotion(duration)
const item = pageFooterItemMotion

const NavigationList = ({ pageFooterInView, style }) => {
  return (
    <nav className="text-5xl sm:text-7xl 3xl:text-18xl font-serif leading-none tracking-normal text-brand-white text-center">
      <motion.ol
        key={"linkListPageFooter"}
        variants={container}
        initial="hidden"
        animate={pageFooterInView ? "show" : "hidden"}
      >
        <motion.li variants={item} key={"featuredLink"}>
          <Link
            to="/"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Featured
          </Link>
        </motion.li>
        <motion.li variants={item} key={"filmLink"}>
          <Link
            to="/film"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Film
          </Link>
        </motion.li>
        <motion.li variants={item} key={"advertLink"}>
          <Link
            to="/advertising"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Advertising
          </Link>
        </motion.li>

        <motion.li variants={item} key={"editorialLink"}>
          <Link
            to="/editorial"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Editorial
          </Link>
        </motion.li>
        <motion.li variants={item} key={"travelLink"}>
          <Link
            to="/travel"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Travel
          </Link>
        </motion.li>
        <motion.li variants={item} key={"archiveLink"}>
          <Link
            to="/archive"
            style={style}
            className="sm:px-12 transition duration-300 ease-in-out hover:text-brand-gray no-underline"
            activeClassName="text-brand-gray"
          >
            Archive
          </Link>
        </motion.li>
      </motion.ol>
    </nav>
  )
}

export default NavigationList
